<div class="application-login-form">
  <h2 class="application-login-form__heading ta-center">Setup</h2>
  <p class="form-subtitle ta-center">Enterprise Information</p>

  <div class="application-card">
    <form [formGroup]="form" (ngSubmit)="createEnterprise()">
      <div class="form-columns">
        <div class="form-left">
          <mat-form-field class="w-100 d-block" floatLabel="always">
            <mat-label>Enterprise Name</mat-label>
            <input
              matInput
              type="text"
              formControlName="enterpriseName"
              required
            />
            <mat-error *ngIf="form.get('enterpriseName')?.hasError('required')">
              Enterprise Name is required.
            </mat-error>
          </mat-form-field>

          <mat-form-field class="w-100 d-block" floatLabel="always">
            <mat-label>Enterprise Street</mat-label>
            <input
              matInput
              type="text"
              name="enterpriseStreet"
              formControlName="enterpriseStreet"
              required
            />
            <mat-error *ngIf="formData.enterpriseStreet === ''">
              Street Address is required.
            </mat-error>
          </mat-form-field>

          <mat-form-field class="w-100 d-block" floatLabel="always">
            <mat-label>City</mat-label>
            <input
              matInput
              type="text"
              name="enterpriseCity"
              formControlName="enterpriseCity"
              required
            />
            <mat-error *ngIf="formData.enterpriseCity === ''">
              City is required.
            </mat-error>
          </mat-form-field>

          <div class="flex-row">
            <mat-form-field class="flex-item" floatLabel="always">
              <mat-label>State</mat-label>
              <input
                matInput
                type="text"
                name="enterpriseState"
                formControlName="enterpriseState"
                required
              />
              <mat-error *ngIf="formData.enterpriseState === ''">
                State is required.
              </mat-error>
            </mat-form-field>

            <mat-form-field class="flex-item" floatLabel="always">
              <mat-label>Zip</mat-label>
              <input
                matInput
                type="text"
                name="enterpriseZip"
                formControlName="enterpriseZip"
                required
              />
              <mat-error *ngIf="formData.enterpriseZip === ''">
                Zip is required.
              </mat-error>
            </mat-form-field>
          </div>
        </div>

        <div class="form-right">
          <mat-form-field class="w-100 d-block" floatLabel="always">
            <mat-label>Enterprise Website</mat-label>
            <input
              matInput
              type="text"
              name="enterpriseWebsite"
              formControlName="enterpriseWebsite"
            />
          </mat-form-field>

          <mat-form-field class="w-100 d-block" floatLabel="always">
            <mat-label>Timezone</mat-label>
            <mat-select name="timezone" formControlName="timezone" required>
              <mat-option
                *ngFor="let timezone of timezones"
                [value]="timezone.name"
              >
                {{ timezone.name }} ({{ timezone.abbrev }})
              </mat-option>
            </mat-select>
            <mat-error *ngIf="formData.timezone === ''">
              Timezone is required.
            </mat-error>
          </mat-form-field>

          <div class="form-group">
            <div
              class="logo-upload-container"
              [ngStyle]="{
                'background-color': formData.imageUrl ? 'transparent' : '#e5e7eb',
                'background-image': formData.imageUrl ? 'url(' + formData.imageUrl + ')' : 'url(https://s3-alpha-sig.figma.com/img/4e35/3b65/47f6fe1eb7d6227268330f25f048b4a6?Expires=1734307200&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4&Signature=YXDd7aJkD4229dR1lnEOrAzYfV667f12tCE3MtcwR1steMLSxGgy8fRwkeqQmkshrmg8PSEt7ZCrHRVGlQwsjrAa~OkWIypmTMj~e~ovejLY5cPjNN7JyEmm2bVYiWNhFx0MN0neRvKLgfLdy5AH0ZaLYSBHgu5ujdNFHc79bDcxfjyxzsrlZIPWroUldIXSN9Sj~qIJX25MheRi6kIw7qHUcCYS23QtAPtjc0dAHr-ZcBSzOWOwM9ggb58Aq6Bttuz3NZZ43yCb1YNJ1doKVX8pKCz0vGU9Zgr3EhXiKjJBH0EOHn9O4LezOXRePJKGonuYEP1noOE6TDnJOZmIaQ__)',
                'background-size': 'cover',
                'background-position': 'center',
                'height': '200px',
                'width': '100%',
                'border-radius': '8px',
                'display': 'flex',
                'justify-content': 'center',
                'align-items': 'center',
                'position': 'relative'
              }"
            >
              <ng-container *ngIf="!uploading; else uploadingTemplate">
                <button
                  mat-raised-button
                  color="primary"
                  (click)="uploadButtonClick()"
                  class="upload-button"
                  type="button"
                >
                  Upload Logo
                </button>
                <input
                  type="file"
                  #fileInput
                  style="display: none"
                  id="enterpriseLogo"
                  (change)="handleImageUpload($event)"
                  accept="image/png, image/jpeg"
                />
              </ng-container>
              <ng-template #uploadingTemplate>
                <mat-spinner></mat-spinner>
              </ng-template>
            </div>
          </div>
        </div>
      </div>

      <button
        mat-raised-button
        color="primary"
        type="submit"
        class="submit-button w-100"
        [disabled]="form.invalid"
        style="display: flex; flex-direction: row-reverse"
      >
        <span style="margin-right: 15px">Add Enterprise</span>
        <mat-icon>keyboard_arrow_right</mat-icon>
      </button>
    </form>
  </div>
</div>

<style>
  .application-login-form {
    display: flex;
    flex-direction: column;
    align-items: center;
    min-height: 100vh;
    justify-content: center;
  }
  .application-card {
    background-color: white;
    padding: 30px;
    border-radius: 8px;
    width: 80%;
    max-width: 800px;
  }
  .form-columns {
    display: flex;
    justify-content: space-between;
  }
  .form-left,
  .form-right {
    width: 48%;
  }
  .flex-row {
    display: flex;
    justify-content: space-between;
  }
  .flex-item {
    width: 48%;
  }
  .submit-button {
    margin-top: 30px;
  }
  .upload-button {
    position: relative;
  }
</style>
